import { computed, inject } from 'vue'
import { TELEPORT_ID_KEY } from './consts'

export default function useTeleport() {
    const toTeleportIdValue = inject(TELEPORT_ID_KEY, undefined)

    const toTeleportId = computed(() => {
        return toTeleportIdValue ? `#${toTeleportIdValue}` : undefined
    })

    const enabled = computed(() => !!toTeleportId.value)

    return {
        toTeleportId,
        enabled,
    }
}
